<template>
  <div class="question">
    <div v-if="decision === null || forceWait" class="loading">
      <loading />
    </div>
    <div v-else-if="decision.decision === 'approved'">
      <h1 v-if="clientMode" class="congrats">
        Congratulations! You have been approved*
      </h1>
      <h1 v-else class="congrats">
        Congratulations! Your client has been approved*
      </h1>
      <div class="table">
        <h2>Indicative Offer details:</h2>
        <div v-for="(item, index) in tableData" :key="index" class="row">
          <h3 class="heading">{{ item.title }}</h3>
          <h3>{{ item.value }}</h3>
        </div>
      </div>
      <div class="table">
        <h2>Based on the following:</h2>
        <div v-for="(item, index) in infoData" :key="index" class="row">
          <h3 class="heading">{{ item.title }}</h3>
          <h3>{{ item.value }}</h3>
        </div>
      </div>
      <div class="comment">
        <h2>What happens next:</h2>
        <br />
        <p class="disclaimer" v-if="clientMode">
          *Our aim is to have this facility live and funds in your hands within
          48 hours subject to your assistance with our necessary processes to
          completion. We will be in touch within the next three hours to take
          this offer to the next stage. This offer is subject to final searches.
        </p>
        <p class="disclaimer" v-else>
          *Our aim is to have this facility live and funds in your client's
          hands within 48 hours subject to your client's assistance with our
          necessary processes to completion. We will be in touch within the next
          three hours to take this offer to the next stage. This offer is
          subject to final searches.
        </p>
      </div>
    </div>
    <div class="refer" v-else-if="decision.decision === 'referred'">
      <h1 v-if="clientMode">
        This application has been referred to our underwriters
      </h1>
      <h1 v-else>
        This application would require manual review. Click apply to have the
        underwriters review it
      </h1>
    </div>
    <div v-else class="decline">
      <h1 v-if="clientMode">
        Unfortunately your application has been declined based on the
        information supplied
      </h1>
      <h1 v-else>
        Unfortunately this application would be declined based on the
        information provided
      </h1>
    </div>
    <div v-if="decision !== null && !forceWait" class="buttonBar">
      <div @click="$router.push('/')" class="button Enabled">
        <h3>Home</h3>
      </div>
      <div v-if="!$store.state.clientMode" @click="next" class="button Enabled">
        <h3>Submit</h3>
      </div>
    </div>
  </div>
</template>

<script>
import loading from "@/components/loading";
export default {
  components: {
    loading,
  },
  methods: {
    next: function () {
      if (this.$store.state.quotationOnly) {
        this.$router.push("submitQuote");
      } else {
        this.$router.push("/");
      }
    },
  },
  computed: {
    clientMode: function () {
      return this.$store.state.clientMode;
    },
    infoData: function () {
      return [
        {
          title: "Business Name",
          value: this.$store.state.formData.businessName,
        },
        {
          title: "Company Reg",
          value: this.$store.state.formData.companyReg,
        },
        {
          title: "Industry Sector",
          value: this.$store.state.formData.sector,
        },
        {
          title: "Projected Turnover",
          value: this.$store.state.formData.turnover,
        },
        {
          title: "Number of years trading",
          value: this.$store.state.formData.yearsTrading,
        },
        {
          title: "Expected Customers",
          value: this.$store.state.formData.customers,
        },
      ];
    },
    tableData: function () {
      if (this.$store.state.hidePrice === true) {
        return [
          {
            title: "Funding Limit",
            value:
              "£" +
              parseInt(this.decision.fundingLimit).toLocaleString(undefined, {
                maximumFractionDigits: 2,
              }),
          },
          {
            title: "Cash Available within",
            value: this.decision.cashAvailableWithinHours + " hours",
          },
          {
            title: "Prepayment",
            value: this.decision.prepayment + "%",
          },
          {
            title: "Facility",
            value: this.decision.facility,
          },
        ];
      }
      return [
        {
          title: "Funding Limit",
          value:
            "£" +
            parseInt(this.decision.fundingLimit).toLocaleString(undefined, {
              maximumFractionDigits: 2,
            }),
        },
        {
          title: "Annual Renewal Fee",
          value: "£" + this.decision.annualRenewalFee,
        },
        {
          title: "Debtor Protection",
          value: this.decision.badDebtProtection + "% (optional)",
        },
        {
          title: "Cash Available within",
          value: this.decision.cashAvailableWithinHours + " hours",
        },
        {
          title: "Discount Fee",
          value: this.decision.discountFee + "% over our base rate",
        },
        {
          title: "Service Fee",
          value: this.decision.serviceFee + "%",
        },
        {
          title: "Prepayment",
          value: this.decision.prepayment + "%",
        },
        {
          title: "Facility",
          value: this.decision.facility,
        },
      ];
    },
  },
  data: function () {
    return {
      decision: null,
      forceWait: true,
    };
  },
  mounted: function () {
    if (process.env.VUE_APP_MODE !== "production") {
      this.$gtag.event("stagingDecide");
    } else {
      this.$gtag.event("decide");
    }
    let yearsParsed = 0;
    let phoenix = this.$store.state.formData.yearsTrading === "Phoenix";
    if (this.$store.state.formData.yearsTrading === "1 - 3 years") {
      yearsParsed = 2;
    }
    if (this.$store.state.formData.yearsTrading === "3+ years") {
      yearsParsed = 3;
    }
    if (this.$store.state.testMode === true) {
      alert("This app is running in test mode and will not be followed up");
    }
    // turn the artificial wait off after 2.2s
    setTimeout(() => {
      this.forceWait = false;
    }, 2200);
    this.axios
      .post("/api/decide", {
        introducerId: this.$store.state.introducerId,
        quotationOnly:
          this.$store.state.testMode === true ||
          this.$store.state.quotationOnly === true,
        name: this.$store.state.formData.businessName,
        companyNumber: this.$store.state.formData.companyReg,
        companyType: this.$store.state.formData.companyType,
        sector: this.$store.state.formData.sector,
        turnover: this.$store.state.formData.turnover,
        homeowners: this.$store.state.formData.homeOwners,
        yearsTrading: yearsParsed,
        startup: this.$store.state.formData.yearsTrading === "Start-up",
        phoenix: phoenix,
        expectedCustomers: this.$store.state.formData.customers,
        creditControl: this.$store.state.formData.creditControl,
        contactName: this.$store.state.contact.name,
        contactNumber: this.$store.state.contact.number,
        contactEmail: this.$store.state.contact.email,
      })
      .then((res) => {
        this.decision = res.data.decision;
      })
      .catch((err) => {
        // eslint-disable-next-line no-console
        console.log(err);
      });
  },
};
</script>

<style lang="scss" scoped>
.congrats {
  color: green;
  font-weight: bolder;
  margin: 1em;
}
.refer {
  height: 100%;
  display: flex;
  align-items: center;
  margin: 1em;
}
.decline {
  height: 100%;
  display: flex;
  align-items: center;
  h1 {
    font-weight: bolder;
    color: rgb(212, 24, 24);
    margin: 1em;
  }
}
.comment {
  text-align: left;
  padding: 2em;
}
.loading {
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 30vw;
  @media screen and (orientation: portrait) {
    width: 100vw;
  }
}
.buttonBar {
  display: flex;
  flex-direction: row;
  justify-content: space-evenly;
  align-items: center;
  width: 100%;
  margin: 2em;
}
.disclaimer {
}
.heading {
  font-weight: bold;
}
.row {
  display: grid;
  grid-template-columns: 1fr 1fr;
  margin-bottom: 0.5em;
  padding: 0.5em;
  //outline: solid var(--base-colour, #535450) 1px;
  background-color: rgba(255, 255, 255, 0.5);
  text-align: left;
  padding-left: 0.5em;
  column-gap: 1em;
  @media (min-width: 450px) {
    padding-left: 3em;
  }
  h3 {
    font-size: large;
    @media (min-height: 750px) {
      font-size: x-large;
    }
  }
}
.table {
  h2 {
    margin-left: 1em;
    margin-bottom: 0.5em;
  }
  text-align: left;
  margin-top: 2em;
  margin-bottom: 2em;
}

.question {
  display: flex;
  flex-shrink: 2;
  align-items: center;
  justify-content: space-between;
  flex-direction: column;
  padding-left: 0;
  padding-right: 0;
  padding-top: 1em;
  padding-bottom: 1em;
  max-width: 100vw;
  * {
    max-width: 100vw;
  }
}
</style>